var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('router-view'),(_vm.isLargeScreen)?_c('Guide'):_vm._e(),_c('Footer'),_c('div',[_c('a-back-top'),_c('strong',{staticStyle:{"color":"rgba(64, 64, 64, 0.6)"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }